import { SelectContentProps } from 'components/ui/Forms';
import { useAuth } from 'hooks/auth';
import { api } from 'services/api';

export function useWarehouse() {
  const { token } = useAuth();
  const getWarehouses = async (): Promise<SelectContentProps[]> => {
    const { data } = await api.get(`/warehouses?asList=1`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data.map((wharehouse: any) => ({
      value: wharehouse.id,
      name: `${wharehouse.tradeName} - ${wharehouse.document}`,
    }));
  };

  const getWarehouse = async (id: string): Promise<any> => {
    const { data } = await api.get(`/warehouses/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data;
  };

  return { getWarehouses, getWarehouse };
}
